<template>
  <div class="mx-auto my-10 text-neutral-900 md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl mobile:my-3">
    <div
      v-if="isNotFound || isGone"
      class="flex flex-col items-center gap-5 text-center"
    >
      <NuxtImg
        :src="'/img/error/error.svg'"
        alt="leaves"
        title="leaves"
        width="240px"
      />
      <KikHeading
        title="An error occured"
        :description="$t(isNotFound ? 'error_404_message' : 'error_410_message')"
      />
      <NuxtLink
        class="text-primary-700 underline"
        to="/"
      >
        {{ $t("Back to homepage") }}
      </NuxtLink>
      <KikButton
        variant="primary"
        @click="router.back()"
      >
        {{ $t("Go back") }}
      </KikButton>
    </div>
    <div v-else>
      <p>{{ $i18n.t('You will be redirected...') }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { RedirectBuilder, WrapperProps } from './Redirect.model';
import { magnoliaGetters } from '~/composables/getters';
import { useMagnolia } from '~/composables/custom/useMagnolia/useMagnolia';
import { useSSR } from '~/composables/useSSR/useSSR';

defineComponent({ name: 'RedirectPage' });

const props = defineProps(WrapperProps);
const mgnlProps = RedirectBuilder.build(props);

const { $domain, $i18n } = useNuxtApp();

const { status } = mgnlProps;
const router = useRouter();
const event = useRequestEvent();
const { onSSR } = useSSR();

const redirectLink = magnoliaGetters.getLinkAndName(mgnlProps, $domain.cmsAssetDomainPath, mgnlProps.switchable?.inLinkParam).url;
const statusCode = Number(status);
const { atMagnoliaPreview } = useMagnolia();

const isNotFound = statusCode === 404;
const isGone = statusCode === 410;

onSSR(() => {
  if (event && statusCode) {
    setResponseStatus(event, statusCode);
  }
});

onBeforeMount(() => {
  if (!isNotFound && !isGone && statusCode && redirectLink && !atMagnoliaPreview.value) {
    navigateTo(redirectLink, { redirectCode: statusCode, external: true });
  }
});
</script>
